import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LeftArrow } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  Typography,
  Avatar,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import PersonAdd from '../Icons/PersonAdd';
import { AvatarGroup } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PLAYBOOK_INTERNAL_PAGE } from '../../../core-utils/routes';

export interface BasicNavbarProps {
  title: string;
  acceptedBy?: string[];
}

const BasicNavbar: React.FC<BasicNavbarProps> = ({ title, acceptedBy }) => {
  const useStyles = makeStyles()({
    root: {
      height: '60px',
      backgroundColor: '#fff',
      padding: '0.5rem 1rem',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,

      position: 'fixed',
      top: '0',
      width: '100%',
      zIndex: 99,
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      cursor: 'pointer',
    },
    invite: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      cursor: 'pointer',
    },
  });
  const { classes } = useStyles();
  const navigate = useNavigate();
  const extractInitials = (name: string) => {
    const parts = name?.trim()?.split(' ');

    const initials = parts?.map((part) => part[0].toUpperCase()).join('');
    return initials;
  };
  return (
    <Grid container className={classes.root}>
      <Grid
        className={classes.title}
        onClick={() => navigate(PLAYBOOK_INTERNAL_PAGE)}
      >
        <LeftArrow
          height="14px"
          width="14px"
          fill={patientAccessTheme.palette.text.highemphasis}
        />
        <Typography fontSize="18px" fontType="medium">
          {title}
        </Typography>
      </Grid>
      <Grid className={classes.invite}>
        <PersonAdd
          width="24px"
          height="24px"
          fill={patientAccessTheme.palette.primary.main}
        />
        <Typography
          fontSize="14px"
          fontType="semiBold"
          textColor={patientAccessTheme.palette.primary.main}
        >
          Invite
        </Typography>

        {acceptedBy && acceptedBy.length > 0 && (
          <AvatarGroup max={2}>
            {acceptedBy?.map((avatarData) => (
              <Avatar
                avatarText={
                  <Typography
                    textColor={patientAccessTheme.palette.primary.main}
                    fontType="semiBold"
                    fontSize="12px"
                  >
                    {extractInitials(avatarData)}
                  </Typography>
                }
                height="32px"
                width="32px"
                backgroundColor={patientAccessTheme.palette.grey[300]}
                alt={''}
                style={{ margin: '0px 10px 0px 0px' }}
              />
            ))}
          </AvatarGroup>
        )}
      </Grid>
    </Grid>
  );
};
export default BasicNavbar;
